'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function HashScroll() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const hash = window.location.hash?.replace('#', '');
    if (!hash) return;

    let frame = 0;
    let attempts = 0;
    const MAX_ATTEMPTS = 40;

    let prevTop: number | null = null;

    const tick = () => {
      const el = document.getElementById(hash);
      if (el) {
        const top = el.getBoundingClientRect().top;
        if (prevTop !== null && Math.abs(top - prevTop) < 1) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        prevTop = top;
      }

      if (attempts++ < MAX_ATTEMPTS) {
        frame = window.setTimeout(tick, 50);
      }
    };

    tick();

    return () => {
      if (frame) window.clearTimeout(frame);
    };
  }, [pathname]);

  return null;
}
